import { render, staticRenderFns } from "./AdditionalFiltersModal.vue?vue&type=template&id=806b3b0c&scoped=true"
import script from "./AdditionalFiltersModal.vue?vue&type=script&lang=js"
export * from "./AdditionalFiltersModal.vue?vue&type=script&lang=js"
import style0 from "./AdditionalFiltersModal.vue?vue&type=style&index=0&id=806b3b0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806b3b0c",
  null
  
)

export default component.exports